import CustomOptionSelector, {
  OptionSelectorProps,
} from '@new-components/molecules/CustomOptionSelector';

const AvailabilitySelector = (props: OptionSelectorProps) => {
  return <CustomOptionSelector {...props} />;
};
export default AvailabilitySelector;
